export class SafetyMitigation {
    id!: string
    chartLabel!: string
    description!: string
    date!: Date
    y!: number
    dateLabelYear!: string
    dateLabelQuarter!: string
    dateLabelMonth!: string
    pointIndex = 0
}
